import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { categoriesArrayPropTypes, productsArrayPropTypes, slidersArrayPropTypes } from 'helpers/propTypes';
import { MOST_SELLED, NEW_ARRIVALS, OFFERS } from 'views/Home/constants';
import { sendNewsletter } from 'redux/actions/user.actions';

import ItemContainer from 'containers/ItemContainer';
import Home from 'views/Home';
import HomeTextil from 'views/Home/HomeTextil';
import HomeD5 from 'views/Home/HomeD5';
import HomeD7 from 'views/Home/HomeD7';
import HomeMan from 'views/Home/HomeMan';
import HomeD8 from 'views/Home/HomeD8';
import { getStoreDesign, getStoreHomePresentation } from 'constants/storeDesigns';
import { getCustomDesignSettings, isCustomDesign } from 'constants/customDesign';
import { getClientTheme } from 'constants/clientThemes';
import HomeLibreria from 'views/Home/HomeLibreria';

const HomeContainer = (props) => {
  const {
    addresses, cartel, categories, categoriesHome, instagram, loadingProd, loadingMostSelled, marcasHome, newArrivals,
    minimumPurchase, offers, sliders, sendNewsletterAction, subCategoriesHome, mostSelled, loadingOffers, client,
    loading, products, loadingNewsletter,
  } = props;
  const initialSection = client?.design === 8 ? NEW_ARRIVALS : (client && !!client.design ? -1 : NEW_ARRIVALS);
  const [currentSection, setCurrentSeccion] = useState(initialSection);
  const [currentSection1, setCurrentSeccion1] = useState(-1);
  const [newsletter, setNewsletter] = useState('');
  const [items, setItems] = useState(newArrivals);

  // No mutar arrays de Redux: ordenar en copia.
  const sortByIdDesc = (arr = []) => [...(arr || [])].sort((a, b) => (Number(b?.id) || 0) - (Number(a?.id) || 0));

  const cantMedidasMax = Math.max(
    ...products.map(item => {
      const descripcionesFiltradas = item.stock_product_descriptions?.filter(
        desc => desc.stock_descriptions?.stock_category_id === 2
      ) || [];

      const nombres = descripcionesFiltradas.map(desc => desc.stock_descriptions?.name);
      const nombresUnicos = new Set(nombres);

      const incluyeUno = nombresUnicos.has('1') || nombresUnicos.has(1);

      return nombresUnicos.size - (incluyeUno ? 1 : 0);
    })
  );

  const setNewSection = (newSection) => {
    switch (newSection) {
      case OFFERS.value:
        setCurrentSeccion(OFFERS);
        setItems(offers);
        break;
      case MOST_SELLED.value:
        setCurrentSeccion(MOST_SELLED);
        setItems(mostSelled);
        break;
      default:
        setCurrentSeccion(NEW_ARRIVALS);
        setItems(newArrivals);
        break;
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    if (client && !client.design) setNewSection(NEW_ARRIVALS)
    // eslint-disable-next-line
  }, [mostSelled, newArrivals, offers]);

  useEffect(() => {
    if (client?.design !== 8) return;

    const desired = currentSection?.value || NEW_ARRIVALS.value;
    setNewSection(desired);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?.design, mostSelled, newArrivals, offers]);

  const filterItems = (subcat) => {
    if (subcat) {
      setCurrentSeccion(subcat.subCategory_id);
    } else {
      setCurrentSeccion(-1);
    }
  };

  const filterItems1 = (subcat) => {
    if (subcat) {
      setCurrentSeccion1(subcat.subCategory_id);
    } else {
      setCurrentSeccion1(-1);
    }
  };

  const renderItem = (item) => {
    switch (client?.design) {
      case 3:
        return (
          <div className="col-product-textil" style={{ background: 'rgb(249 249 249)', borderRadius: '16px' }} key={`item-${item.id}`}>
            <ItemContainer item={item} cantMedidasMax={cantMedidasMax} />
          </div>
        );
      default:
        return (
          <div className={`col-product${client && !!client.design ? '' : '-simple'}`} style={{ background: 'rgb(249 249 249)', borderRadius: '16px'  }} key={`item-${item.id}`}>
            <ItemContainer item={item} />
          </div>
        );
    }
  };

  const submitNewsletter = (email = newsletter) => {
    const emailValue = email && typeof email.preventDefault === 'function' ? newsletter : email;
    const cleanEmail = String(emailValue || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail)) {
      return false;
    }

    const value = { email: cleanEmail };
    sendNewsletterAction(value);
    setNewsletter('');
    return true;
  };
  const newsletterProps = {
    newsletter,
    setNewsletter,
    submitNewsletter,
    loadingNewsletter,
    client,
  };

  const designsMap = {
    0: newArrivals,
    1: products,
    2: products,
  };
  const storeDesign = getStoreDesign(client?.design);

  if (getClientTheme(client) === 'libreria-regaleria') {
    return (
      <HomeLibreria
        client={client}
        categoriesHome={categoriesHome}
        mostSelled={sortByIdDesc(mostSelled)}
        featuredProducts={sortByIdDesc(newArrivals)}
        offers={offers}
        sliders={sliders}
        renderItem={renderItem}
        {...newsletterProps}
      />
    );
  }

  if (isCustomDesign(client)) {
    const customSettings = getCustomDesignSettings(client);
    const useEditorialHome = ['editorial', 'grid'].includes(customSettings.layout);

    if (useEditorialHome) {
      return (
        <HomeMan
          categories={categories}
          categoriesHome={categoriesHome}
          marcasHome={marcasHome}
          mostSelled={sortByIdDesc(mostSelled)}
          featuredProducts={sortByIdDesc(newArrivals)}
          offers={offers}
          sliders={sliders}
          cartel={cartel}
          renderItem={renderItem}
          {...newsletterProps}
          customHtml={customSettings.customHtml}
          variant="custom-design"
        />
      );
    }

    return (
      <HomeD5
        categories={categories}
        categoriesHome={categoriesHome}
        marcasHome={marcasHome}
        mostSelled={sortByIdDesc(mostSelled)}
        featuredProducts={sortByIdDesc(newArrivals)}
        offers={offers}
        renderItem={renderItem}
        sliders={sliders}
        cartel={cartel}
        {...newsletterProps}
        disableProductCarousel={customSettings.layout === 'minimal'}
        customHtml={customSettings.customHtml}
        variant="custom-design"
      />
    );
  }

  if (storeDesign) {
    const presentation = getStoreHomePresentation(storeDesign.slug);

    if (storeDesign.home === 'man') {
      return (
        <HomeMan
          categories={categories}
          categoriesHome={categoriesHome}
          marcasHome={marcasHome}
          mostSelled={sortByIdDesc(mostSelled)}
          featuredProducts={sortByIdDesc(newArrivals)}
          offers={offers}
          sliders={sliders}
          cartel={cartel}
          renderItem={renderItem}
          {...newsletterProps}
          variant={storeDesign.slug}
          presentation={presentation}
        />
      );
    }

    return (
      <HomeD5
        categories={categories}
        categoriesHome={categoriesHome}
        marcasHome={marcasHome}
        mostSelled={sortByIdDesc(mostSelled)}
        featuredProducts={sortByIdDesc(newArrivals)}
        offers={offers}
        renderItem={renderItem}
        sliders={sliders}
      cartel={cartel}
      {...newsletterProps}
      disableProductCarousel={presentation.products !== 'carousel' || storeDesign.productCard === 'soft'}
      variant={storeDesign.slug}
      presentation={presentation}
    />
  );
  }

  switch (client?.design) {
    case 3:
      return (
        <HomeTextil
          categoriesHome={categoriesHome}
          mostSelled={mostSelled}
          featuredProducts={newArrivals}
          renderItem={renderItem}
          sliders={sliders}
          cartel={cartel}
          forceHeroCarousel
          {...newsletterProps}
        />
      );
    case 5:
      return (
        <HomeD5
          categories={categories}
          categoriesHome={categoriesHome}
          marcasHome={marcasHome}
          mostSelled={sortByIdDesc(mostSelled)}
          featuredProducts={sortByIdDesc(newArrivals)}
          offers={offers}
          submitNewsletter={submitNewsletter}
          renderItem={renderItem}
          sliders={sliders}
          cartel={cartel}
          forceHeroCarousel
          dedicatedHeroCarousel
          {...newsletterProps}
        />
      );
    case 6:
      return (
        <HomeMan
          categories={categories}
          categoriesHome={categoriesHome}
          marcasHome={marcasHome}
          mostSelled={sortByIdDesc(mostSelled)}
          featuredProducts={sortByIdDesc(newArrivals)}
          offers={offers}
          sliders={sliders}
          cartel={cartel}
          renderItem={renderItem}
          dedicatedHeroCarousel
          {...newsletterProps}
        />
      );
    case 7:
      return (
        <HomeD7
          categoriesHome={categoriesHome}
          mostSelled={sortByIdDesc(mostSelled)}
          featuredProducts={sortByIdDesc(newArrivals)}
          submitNewsletter={submitNewsletter}
          renderItem={renderItem}
          sliders={sliders}
          cartel={cartel}
          {...newsletterProps}
          disableProductCarousel
        />
      );
    case 8:
      return (
        <HomeD8
          cartel={cartel}
          categories={categories}
          categoriesHome={categoriesHome}
          currentSection={currentSection}
          instagram={instagram}
          items={items}
          newArrivals={newArrivals}
          mostSelled={mostSelled}
          offers={offers}
          loading={loading}
          marcasHome={marcasHome}
          onSectionClick={setNewSection}
          renderItem={renderItem}
          sliders={sliders}
          getImageHomeSelected={(cat) => cat?.category?.imageHome || ''}
          addresses={addresses}
          linkIg={client?.link_ig}
          {...newsletterProps}
        />
      );
    default:
      return (
        <Home
          cartel={cartel}
          categories={categories}
          categoriesHome={categoriesHome}
          subCategoriesHome={subCategoriesHome}
          currentSection={currentSection}
          currentSection1={currentSection1}
          instagram={instagram}
          items={client ? designsMap[client.design] ?? items : items}
          mostSelled={mostSelled}
          offers={offers}
          loadingProd={loadingProd}
          loadingMostSelled={loadingMostSelled}
          loadingOffers={loadingOffers}
          loading={loading}
          marcasHome={marcasHome}
          minimumPurchase={minimumPurchase}
          onSectionClick={client && !!client.design ? filterItems : setNewSection}
          mostSelledClick={filterItems1}
          renderItem={renderItem}
          sliders={sliders}
          {...newsletterProps}
          tiktok="7132849512812416261"
        />
      );
  }
};

const mapDispatchToProps = (dispatch) => ({
  sendNewsletterAction: bindActionCreators(sendNewsletter, dispatch),
});

const mapStateToProps = (state, props) => ({
  addresses: state.app.addresses,
  cartel: state.category.cartelHome,
  categories: state.category.items,
  client: state.app.client,
  categoriesHome: state.category.itemsHome,
  instagram: state.app.instagram,
  products: state.product.items,
  loadingProd: state.product.loadingProd,
  loadingMostSelled: state.product.loadingMostSelled,
  loadingOffers: state.product.loadingOffers,
  marcasHome: state.category.marcasHome,
  minimumPurchase: state.app.minimumPurchase,
  mostSelled: state.product.mostSelled,
  newArrivals: state.product.newArrivals,
  offers: state.product.offers,
  section: props.match.params.section,
  sliders: state.app.sliders,
  subCategories: state.subCategory.items,
  subCategoriesHome: state.subCategory.itemsHome,
  loadingNewsletter: state.user.loadingNewsletter,
  loading: state.product.loading,
});

HomeContainer.defaultProps = {
  // section: '',
};

HomeContainer.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.shape()),
  cartel: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  categories: categoriesArrayPropTypes.isRequired,
  categoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  instagram: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
  loadingNewsletter: PropTypes.bool.isRequired,
  // loadingNewsletter: PropTypes.bool.isRequired,
  marcasHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  minimumPurchase: PropTypes.number.isRequired,
  mostSelled: productsArrayPropTypes.isRequired,
  newArrivals: productsArrayPropTypes.isRequired,
  offers: productsArrayPropTypes.isRequired,
  products: productsArrayPropTypes.isRequired,
  // section: PropTypes.string,
  sendNewsletterAction: PropTypes.func.isRequired,
  sliders: slidersArrayPropTypes.isRequired,
  subCategoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

HomeContainer.defaultProps = {
  addresses: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
